export default class {

    constructor() {}

        //for all form validation
        
    //email
    validateEmail(email){
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    //alphabets names inputs
    validateName(name){ 
        let re = /^[\w\-\s]+$/;
        return re.test(name);
    }
    //phone number nigeria format
    validatePhoneNumber(phone){ 
        let re = /^\d{4}\d{3}\d{4}$/;
        return re.test(phone);
    }

    //website 
    validateWebsite(url){ 
        //let re = /^(ftp|http|https):\/\/[^ "]+$/;
        //let re = /^((?:https?\:\/\/|www\.)(?:[-a-z0-9]+\.)*[-a-z0-9]+.*)/;
        let re = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
        return re.test(url);
    }
}


// WEBPACK FOOTER //
// ./src/services/validator.js